import { preacherConnector } from 'shared/connectors'
import { PREACHER } from 'store/types'

const success = data => ({
  type: PREACHER.GET_PREACHERS_OPTIONS_SUCCESS,
  payload: {
    data,
  },
})

const failure = () => ({
  type: PREACHER.GET_PREACHERS_OPTIONS_FAILURE,
})

const getPreachersOptions = () => async dispatch => {
  try {
    const { data } = await preacherConnector.getPreachersOptions()
    dispatch(success(data))
  } catch (err) {
    dispatch(failure())
  }
}

export default getPreachersOptions
